import React, { useState } from 'react';
import './HostingCpanelIran.css';

const HostingCpanelIran = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const plans = [
    {
      tier: 'برنزی',
      price: '۱۵۰',
      unit: 'هزار تومان / ماه',
      disk: '۵ گیگابایت NVMe',
      domains: '۵ دامنه addon',
      email: '۵۰ اکانت ایمیل',
      features: ['SSL رایگان', 'بکاپ هفتگی', 'LiteSpeed Cache', 'Cloudflare CDN'],
      popular: false,
    },
    {
      tier: 'نقره‌ای',
      price: '۲۹۰',
      unit: 'هزار تومان / ماه',
      disk: '۱۵ گیگابایت NVMe',
      domains: 'نامحدود دامنه addon',
      email: 'نامحدود ایمیل',
      features: ['SSL رایگان', 'بکاپ روزانه', 'LiteSpeed Cache', 'Cloudflare CDN', 'IP اختصاصی'],
      popular: true,
    },
    {
      tier: 'طلایی',
      price: '۵۵۰',
      unit: 'هزار تومان / ماه',
      disk: '۵۰ گیگابایت NVMe',
      domains: 'نامحدود دامنه addon',
      email: 'نامحدود ایمیل',
      features: ['SSL Wildcard', 'بکاپ روزانه', 'LiteSpeed Cache', 'Cloudflare CDN', 'IP اختصاصی', 'اولویت پشتیبانی'],
      popular: false,
    },
  ];

  const features = [
    {
      icon: '⚡',
      title: 'سرورهای NVMe فوق‌سریع',
      desc: 'استفاده از دیسک‌های NVMe با سرعت خواندن و نوشتن بالا برای بارگذاری سریع‌تر وب‌سایت شما. عملکرد تا ۱۰ برابر بهتر از هاست‌های معمولی.',
    },
    {
      icon: '🛡️',
      title: 'امنیت پیشرفته با Imunify360',
      desc: 'محافظت کامل از وب‌سایت شما در برابر حملات سایبری، بدافزارها و هک. سیستم امنیتی پیشرفته Imunify360 به صورت خودکار از سایت شما محافظت می‌کند.',
    },
    {
      icon: '🇮🇷',
      title: 'لوکیشن ایران با پینگ پایین',
      desc: 'سرورهای ما در داخل ایران قرار دارند و پینگ بسیار پایینی برای کاربران ایرانی دارند. سرعت بارگذاری وب‌سایت شما برای مخاطبان داخلی فوق‌العاده خواهد بود.',
    },
    {
      icon: '📧',
      title: 'ایمیل سازمانی با cPanel',
      desc: 'ایجاد ایمیل‌های حرفه‌ای با دامنه اختصاصی خودتان. مدیریت کامل ایمیل‌ها از طریق کنترل پنل cPanel با امکانات پیشرفته.',
    },
  ];

  const faqs = [
    {
      q: 'هاست cPanel ایران چه مزایایی نسبت به هاست خارج دارد؟',
      a: 'هاست cPanel ایران با قرارگیری روی سرورهای داخل کشور، سرعت بارگذاری بسیار بالاتری برای کاربران ایرانی دارد (پینگ پایین‌تر). همچنین با قوانین داخلی سازگار است و برای وب‌سایت‌های فارسی و فروشگاه‌های آنلاین داخلی گزینه‌ای ایده‌آل است. پشتیبانی فارسی ۲۴ ساعته و قیمت‌های رقابتی از دیگر مزایای هاست cPanel ایران در افرسل است.',
    },
    {
      q: 'آیا امکان ارتقا هاست cPanel ایران وجود دارد؟',
      a: 'بله، شما می‌توانید در هر زمان از پنل مدیریتی خود، هاست خود را به پلن بالاتر ارتقا دهید. فرآیند ارتقا به صورت خودکار انجام می‌شود و وب‌سایت شما هیچ گونه قطعی نخواهد داشت. منابع جدید بلافاصله در اختیار شما قرار می‌گیرند و می‌توانید از فضای بیشتر، دامنه‌های اضافی و امکانات پیشرفته‌تر استفاده کنید.',
    },
  ];

  return (
    <>
      <div className="seo-header">
        <h1>هاست cPanel ایران | خرید هاست سی پنل با بهترین قیمت | افرسل</h1>
        <p>خرید هاست cPanel ایران با سرورهای NVMe، پشتیبانی ۲۴ ساعته و آپتایم ۹۹.۹٪. هاست سی پنل مناسب برای وب‌سایت‌های فارسی، فروشگاه‌های آنلاین و کسب‌وکارهای ایرانی.</p>
        <meta name="description" content="خرید هاست cPanel ایران با بهترین قیمت از افرسل. هاست سی پنل با سرورهای NVMe، پشتیبانی ۲۴/۷، SSL رایگان و آپتایم ۹۹.۹٪." />
      </div>

      <section className="hosting-cpanel-hero">
        <div className="hosting-cpanel-hero-bg"></div>
        <div className="wrap">
          <div className="hosting-cpanel-hero-content">
            <div className="hosting-cpanel-badge">
              <span className="pulse-dot"></span>
              🖥️ هاست cPanel ایران
            </div>
            <h1 className="hosting-cpanel-hero-title">
              هاست <em>cPanel ایران</em>
            </h1>
            <p className="hosting-cpanel-hero-desc">
              هاست cPanel ایران با سرورهای NVMe فوق‌سریع، پشتیبانی ۲۴ ساعته و آپتایم ۹۹.۹٪. 
              مناسب برای وب‌سایت‌های فارسی، فروشگاه‌های آنلاین و کسب‌وکارهای ایرانی. 
              کنترل پنل cPanel با امکانات کامل و مدیریت آسان وب‌سایت شما.
            </p>
            <div className="hosting-cpanel-hero-stats">
              <div className="stat-item">
                <span className="stat-number">۳</span>
                <span className="stat-label">پلن مختلف</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">NVMe</span>
                <span className="stat-label">دیسک فوق‌سریع</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">۲۴/۷</span>
                <span className="stat-label">پشتیبانی فارسی</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="hosting-cpanel-plans">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">پلن‌های هاست cPanel ایران</span>
            <h2 className="sec-h">پلن <em>مناسب</em> وب‌سایت خود را انتخاب کنید</h2>
            <p className="sec-p">پلن‌های متنوع هاست cPanel ایران با قیمت‌های رقابتی و منابع کافی برای هر نوع وب‌سایت.</p>
          </div>
          <div className="hosting-cpanel-plans-grid">
            {plans.map((plan, i) => (
              <div key={i} className={`hosting-cpanel-plan ${plan.popular ? 'popular' : ''}`}>
                {plan.popular && <span className="hosting-cpanel-popular-badge">پرفروش‌ترین</span>}
                <div className="hosting-cpanel-plan-tier">{plan.tier}</div>
                <div className="hosting-cpanel-plan-price">
                  <span className="hosting-cpanel-plan-num">{plan.price}</span>
                  <span className="hosting-cpanel-plan-unit">{plan.unit}</span>
                </div>
                <div className="hosting-cpanel-plan-specs">
                  <div><span>💾</span> {plan.disk}</div>
                  <div><span>🌐</span> {plan.domains}</div>
                  <div><span>📧</span> {plan.email}</div>
                </div>
                <ul className="hosting-cpanel-plan-features">
                  {plan.features.map((feat, j) => (
                    <li key={j}><span>✓</span> {feat}</li>
                  ))}
                </ul>
                <button className="hosting-cpanel-order-btn" onClick={() => scrollTo('contact')}>سفارش دهید</button>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="hosting-cpanel-features">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">مزایای هاست cPanel ایران</span>
            <h2 className="sec-h">چرا <em>هاست cPanel ایران</em> با افرسل؟</h2>
            <p className="sec-p">هاست cPanel ایران با بهترین امکانات و خدمات برای کسب‌وکارهای ایرانی.</p>
          </div>
          <div className="hosting-cpanel-features-grid">
            {features.map((feature, i) => (
              <div key={i} className="hosting-cpanel-feature-card">
                <span className="hosting-cpanel-feature-icon">{feature.icon}</span>
                <h3 className="hosting-cpanel-feature-title">{feature.title}</h3>
                <p className="hosting-cpanel-feature-desc">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="hosting-cpanel-faq">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">سوالات متداول</span>
            <h2 className="sec-h">پاسخ به <em>سوالات</em> شما</h2>
          </div>
          <div className="hosting-cpanel-faq-grid">
            {faqs.map((faq, i) => (
              <div key={i} className="hosting-cpanel-faq-item">
                <div className="hosting-cpanel-faq-q">{faq.q}</div>
                <div className="hosting-cpanel-faq-a">{faq.a}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="hosting-cpanel-cta">
        <div className="wrap">
          <div className="cta-box">
            <h2 className="cta-title">
              هاست <em>cPanel ایران</em> را همین حالا خریداری کنید
            </h2>
            <p className="cta-desc">
              با خرید هاست cPanel ایران، از سرعت بالا، پایداری عالی و پشتیبانی ۲۴ ساعته بهره‌مند شوید.
            </p>
            <div className="cta-btns">
              <button className="btn-lg primary" onClick={() => scrollTo('contact')}>خرید هاست</button>
              <button className="btn-lg ghost" onClick={() => scrollTo('contact')}>مشاوره رایگان</button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HostingCpanelIran;
